import { autoinject } from "aurelia-framework";
import { InspectionReportTabs } from '@rightship-tech/rs-inspections-ui/views/pages/inspection-report-tabs/inspection-report-tabs';
import { RightshipInspectionService } from "../../../services/rightship-inspection.service";
import { RightShipInspectionDetailsModel } from "../../../models/rightship-inspections.models";
import { CookieHelper } from "@rightship-tech/common-ui/helpers/cookie-helper";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { Router } from "aurelia-router";
import { RsInspectionRouteConstants } from "../../../constants/route.constants";
import { TitleConst } from "../../../constants/title.constaints";

@autoinject
export class InspectionReport {

    public viewModel: InspectionReportTabs;
    public inspectionModel: RightShipInspectionDetailsModel;
    public readonly title: string = TitleConst.InspectionReport;
    public reportModel;


    constructor(private inspectionReportTabs: InspectionReportTabs, 
        private router: Router,
        private rightshipInspectionService: RightshipInspectionService, private configService: ConfigService) {
    }

    async activate(params: { encryptedData: string })
    {
        if (!params.encryptedData) {
            let paramValue = CookieHelper.readCookie(`queryString-${this.configService.config.environment}`);
            CookieHelper.eraseCookie(`queryString-${this.configService.config.environment}`, this.configService.config.environment);
            if (!paramValue.startsWith('?')) {
                paramValue = `?${paramValue}`;
            }
            window.location.href = `/inspection-report${paramValue}`;
            return;
        } 

        try {
            this.inspectionModel = await this.rightshipInspectionService.getRightShipInspectionDetails(decodeURIComponent(params.encryptedData));
    
            const response =  await this.rightshipInspectionService.getInspectionOutcomeReportModel(decodeURIComponent(params.encryptedData));
            
            this.viewModel = this.inspectionReportTabs;
            this.reportModel = {
                viewInDialog: false,
                inspectionId: response.rightShipInspectionId,
                validUntilText: response.validUntilText,
                validUntil: response.validUntil,
                additionalCommentsForDurationOfValidity: response.additionalCommentsForDurationOfValidity,
                summary: response.summary,
                statusName: response.statusName,
                statusId: response.statusId,
                hideShareButton: true,
                customerId: response.customerId,
                formHasBeenSubmitted: response.formHasBeenSubmitted,
                closeoutType: response.closeoutType,
                hasInspectionOutcomeV2: this.inspectionModel.hasInspectionOutcomeV2,
            }
        } catch (error) {

            //return to inspection report unavailable page
            this.router.navigateToRoute(RsInspectionRouteConstants.InspectionReportUnavailable, {
                vesselName: this.inspectionModel?.vesselDetails?.vesselName,
                vesselImo: this.inspectionModel?.vesselDetails?.vesselImo, 
                portName: this.inspectionModel?.portAndOperationalDetails?.port,
                country: this.inspectionModel?.portAndOperationalDetails?.country,
                requestedInspectionDate: this.inspectionModel?.portAndOperationalDetails?.requestedInspectionDate,
                rsInspectionId: this.inspectionModel?.rightShipInspectionId
            });
        }
    }
}